// eufy's app battery icon, for solar cameras' cards. Traced from the app at 3x,
// one unit a pixel. While the sun shines on the card (hooks/useSunlight) it's
// charging, as the app shows it: in its green, with the bolt, the first three
// bars always showing and the other two lighting up one by one (see
// .solar-charging-* in index.css). Otherwise gray with four bars. Only
// decoration; the card's text says the camera runs on a solar panel.
const BARS = [12, 24, 36, 48, 60];

// On larger cards it's as tall as the label across from it (Home/Item.jsx), so
// the two line up.
export default function SolarCharging({ charging = false, className = "" }) {
  return (
    <span aria-hidden="true" className={`flex items-center min-[576px]:h-6 ${charging ? "charging" : ""} ${className}`}>
      <svg
        viewBox="0 0 120 55"
        fill="currentColor"
        className={`w-9 transition-colors duration-500 min-[576px]:w-10 ${charging ? "text-[#3fce7d]" : "text-[#626468]"}`}
      >
        <rect x="3" y="3" width="75" height="49" rx="5" fill="none" stroke="currentColor" strokeWidth="6" />
        <path d="M81 19h6a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-6z" />
        {BARS.map((x, index) => (
          <rect key={x} className={`solar-charging-${index + 1}`} x={x} y="11" width="9" height="32" />
        ))}
        <path
          d="M109.5 9 95 25v3h11l-2 15 15-18h-11.5z"
          className={`transition-opacity duration-500 ${charging ? "" : "opacity-0"}`}
        />
      </svg>
    </span>
  );
}
